export const translateChannelName = (name) => {
  const names = {
    "SUPERARE_WEBVIEW": "Webview",
    "CELL_NOTIFICATION": "Notificações push",
    "AKNA": "Akna",
    "ONE_SIGNAL": "OneSignal",
    "AWS SES": "AWS",
    "ZENVIA": "Zenvia"
  }

  const translated = names[name]
  if ( !translated ) return name
  return translated
}